import {createModelSchema, primitive, identifier,} from 'serializr';

export class User {
    id!: string;
    name!: string;
    email!: string;
    email_verified_at!: Date;
    avatar!: string;
    remember_token!: boolean;
    master_account!: boolean;
    created_at!: Date;
    updated_at!: Date;

    get isMasterAccount(): boolean {
        return (this.master_account == true) ? true : false;
    }
}

createModelSchema(User, {
    id: identifier(),
    name: primitive(),
    email: primitive(),
    email_verified_at: primitive(),
    avatar: primitive(),
    remember_token: primitive(),
    master_account: primitive(),
    created_at: primitive(),
    updated_at: primitive()
});
